<template>
  <span class="app-logo">
    <span class="app-logo__help" :style="{ fontSize: helpSize }">helpme</span><span
      class="app-logo__domain"
      :class="{ 'app-logo__domain--dark': dark }"
      :style="{ fontSize: domainSize }"
    >.garden</span>
  </span>
</template>

<script>
export default {
  name: 'AppLogo',
  props: {
    // Base font-size in rem for the "helpme" part
    size: {
      type: Number,
      default: 1.4,
    },
    // Use on dark backgrounds — makes ".garden" light instead of dark green
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    helpSize() { return `${this.size}rem` },
    domainSize() { return `${(this.size * 0.87).toFixed(2)}rem` },
  },
}
</script>

<style scoped>
@font-face {
  font-family: 'Porkys';
  src: url('@/assets/fonts/PORKYS_.TTF') format('truetype');
}

.app-logo {
  display: inline-flex;
  align-items: baseline;
  line-height: 1;
}

.app-logo__help {
  font-family: 'Porkys', sans-serif;
  color: #4caf50;
}

.app-logo__domain {
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1a3a2a;
}

.app-logo__domain--dark {
  color: rgba(255, 255, 255, 0.85);
}
</style>
